import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const SizeRadioGroup: StyleRule<{ expanded: boolean }> = ({
    expanded,
}) => ({
    paddingBottom: pxToRem(expanded ? 2 : 20),
});

export const SizeContent: StyleRule<{ expanded: boolean }> = ({
    theme,
    expanded,
}) => ({
    marginBottom: expanded ? pxToRem(4) : 0,
    ...theme.siteVariables.textStyles.Text.Roman55,
});
